<template>
  <div class="diagnostics">
    <el-tabs
      v-model="activeName"
      :tab-position="screenWidth > 1023 ? 'left' : 'top'"
    >
      <el-tab-pane name="find_data">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            Diagnostics
          </div>
          <div class="label-desc">diagnostics</div>
        </div>
        <div class="common-title-page">
          <div class="title-wrapper">
            <pods-input ref="podsInput"></pods-input>
            <span class="title">Diagnostics</span>
          </div>
          <div
            class="mb-20 mt-20"
            :class="screenWidth > 1023 ? 'text-right' : 'text-left'"
          >
            <UtcOffsets />
          </div>
          <el-table
            border
            ref="table"
            :data="tableData"
            size="small"
            v-loading="loading"
            :max-height="tableHeight"
          >
            <el-table-column
              label="Serial #"
              prop="Serial"
              width="70px"
            ></el-table-column>
            <el-table-column :label="$t('text.mac_address')" prop="MacAddress">
            </el-table-column>
            <el-table-column label="Last Seen" prop="LastSeen">
              <template slot-scope="scope">
                {{
                  moment
                    .utc(scope.row.LastSeen)
                    .tz($store.state.pods.selectedUtcOffset)
                    .format('DD/MM/YYYY @ hh:mm a')
                }}
              </template>
            </el-table-column>
            <el-table-column
              label="PPM (last 7d)"
              prop="PPM"
              width="90px"
            ></el-table-column>
            <el-table-column label="Offline (7d)" width="80px">
              <template slot-scope="scope">
                <span class="mr-1" v-if="scope.row.Offline[0]"
                  >{{ scope.row.Offline[0] }}d</span
                >
                <span class="mr-1" v-if="scope.row.Offline[1]"
                  >{{ scope.row.Offline[1] }}h</span
                >
                <span class="mr-1" v-if="scope.row.Offline[2]"
                  >{{ scope.row.Offline[2] }}m</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="Battery"
              prop="Battery"
              width="80px"
            ></el-table-column>
            <el-table-column label="Version" width="80px">
              <template slot-scope="scope">
                <div>FW: {{ scope.row.FirmwareVersion }}</div>
                <div>HW: {{ scope.row.HardwareVersion }}</div>
              </template>
            </el-table-column>
            <el-table-column label="Live Status">
              <template slot-scope="scope">
                <div>Sensor: {{ scope.row.ConnectionStatus }}</div>
                <div>Position: {{ scope.row.Position }}</div>
                <div>Falls: {{ scope.row.Falls }}</div>
              </template>
            </el-table-column>
            <el-table-column label="Relayed Through Devices (7d)">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.DeviceArr" :key="index">
                  {{ item }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Relayed Through Device MAC Address (7d)">
              <template slot-scope="scope">
                <div
                  v-for="(item, index) in scope.row.DeviceMacArr"
                  :key="index"
                >
                  {{ item }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { secondFormat } from '../../utils/utils'
import PodsInput from '@/components/PodsInput'
import UtcOffsets from '@/components/UtcOffsets'
import $ from 'jquery'
import moment from 'moment'
import ApiService from '@/services/ReportApiService.js'
import swal from 'sweetalert'

export default {
  data() {
    return {
      moment,
      activeName: 'find_data',
      screenWidth: window.innerWidth,
      loading: false,
      tableData: [],
      filter: '',
      tableHeight: 0
    }
  },
  components: {
    PodsInput,
    UtcOffsets
  },
  mounted: function() {
    window.addEventListener('resize', this.getScreenWidth)
    this.getScreenWidth()
    this.getData()
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 150
      let self = this
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 150
      }
    })
  },
  watch: {
    '$store.state.pods.selectedPod': function() {
      this.getData()
    }
  },
  methods: {
    getScreenWidth() {
      this.screenWidth = window.innerWidth
      if (this.screenWidth < 1023) {
        $('.diagnostics .el-tabs__header').hide()
      } else {
        $('.diagnostics .el-tabs__header').show()
      }
    },
    calculateTableData() {
      this.tableData = this.tableData.map(item => {
        return {
          ...item,
          Offline: secondFormat(item.OfflineSecond),
          MacAddress: this.$store.state.pods.selectedPod.podId,
          Serial: this.$store.state.pods.selectedPod.podId.substring(
            this.$store.state.pods.selectedPod.podId.length - 6
          ),
          DeviceArr: item.Device ? item.Device.split(',') : [],
          DeviceMacArr: item.DeviceMac ? item.DeviceMac.split(',') : []
        }
      })
    },
    getData() {
      if (!this.$store.state.pods.selectedPod.podId) return false
      this.loading = true
      ApiService.GetPodDiagnostics(this.$store.state.pods.selectedPod.podId)
        .then(response => {
          this.loading = false
          if (response.data) {
            this.tableData = [response.data]
            this.calculateTableData()
          }
        })
        .catch(() => {
          this.loading = false
          this.calculateTableData()
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
